import { Empty, Progress } from 'antd'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import NoInterview from 'components/icons/NoInterview.png'
import PluginLiveLogo from 'components/icons/PluginLiveLogo'
import 'jspdf-autotable'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FlexWrap } from '../../components/UIComponents/FormStyles'
import ToggleThreeOptions from '../../components/UIComponents/Toggle/ToggleThreeOptions'
import { convertToNumber } from '../RuleEngine/Components/RuleEngineCommonFunction'
import { EmptyWrapper } from '../Users/Style/style'
import { getTpoPrimaryCardData } from './action'
import {
  jobCategoryFilterData,
  pdfFormatFunction,
} from './Components/CommonFunction'
import { DonutChartPDF } from './Components/DonutChartPDF'
import ExportPDF from './Components/ExportPDF'
import FilterComponent from './Components/FilterComponent'
import PageHeader from './Components/PageHeader'
import {
  BackgroundDiv,
  StyledDrawer,
  StyledDynamicText,
} from './Components/StyledComponent'
import TPOGraphs from './Components/TPOGraphs'
import ShortList from './DashboardPopup/ShortList'
const currentYear = new Date().getFullYear()

export default function TPODashboard({
  getDepartmentList,
  getDomainList,
  getDegreeList,
  getJobCategory,
  getSpecializationList,
  getYear,
  // filteredDashboardDetails,
  dashboardDetails,
  setFilteredDashboardDetails,
  getInstituteDetailsFromCampusId,
  getTPOMetrics,
  getJobProfileStatus,
  getCTCAnalysis,
  getActiveJobRoles,
  getStudentPlacement,
}) {
  const dispatch = useDispatch()
  const instituteDetails = useSelector(state => state.auth.instituteDetails)

  const filteredDashboardDetails = useSelector(
    state => state?.tpoDashboard?.filteredDashboardDetails
  )
  const jobProfileStatusDetails = useSelector(
    state => state?.tpoDashboard.jobProfileStatusDetails
  )
  const ctcCategory = useSelector(state => state?.tpoDashboard?.ctcCategory)
  const ctcAnalysis = useSelector(state => state?.tpoDashboard?.ctcAnalysis)
  const activeJobRoles = useSelector(
    state => state?.tpoDashboard?.activeJobRoles
  )
  const studentPlacement = useSelector(
    state => state?.tpoDashboard?.studentPlacement
  )
  const compareJobProfileStatusDetails = useSelector(
    state => state?.tpoDashboard?.compareJobProfileStatusDetails
  )

  const compareCtcCategory = useSelector(
    state => state?.tpoDashboard?.compareCtcCategory
  )
  const compareCtcAnalysis = useSelector(
    state => state?.tpoDashboard?.compareCtcAnalysis
  )

  const compareStudentPlacement = useSelector(
    state => state?.tpoDashboard?.compareStudentPlacement
  )

  const [instituteCampusId, setInstituteCampusId] = useState('')
  const [jobCategories, setJobCategories] = useState([])
  const [showApprovalDrawer, setShowApprovalDrawer] = useState(false)

  const [apiState, setApiState] = useState({
    domainId: '',
    degreeId: '',
    degreeType: '',
    departmentId: '',
  })
  const [stateList, setStateList] = useState({
    domainList: [],
    degreeList: [],
    departmentList: [],
    specializationList: [],
    passingYearList: [],
  })

  const [state, setState] = useState({
    selectedDomain: [],
    selectedDegree: [],
    selectedDepartment: [],
    selectedCourses: [],
    selectedCategory: '',
    selectedSpecialization: [],
    selectedPassingYear: '',
    isLoadData: false,
    placementDataYear: currentYear,
    selectedDegreeType: [],
    compareYear: '',
    isCompareYear: false,
  })

  const [isLoadingState, setIsLoadingState] = useState({
    isDashboardLoading: false,
    isFilteredDashboardLoading: false,
  })

  const [isExport, setIsExport] = useState(false)
  const [isDownload, setIsDownload] = useState(false)
  const [exportData, setExportData] = useState({
    jobProfileStatus: false,
    studentPlacement: false,
    ctcBased: false,
    ctcCategory: false,
  })
  const [yearData, setYearData] = useState([])
  const [step, setStep] = useState(1)
  const [payloadState, setPayloadState] = useState([])
  const activeJobRolesRef = useRef(null)
  const jobProfileStatusRef = useRef(null)
  const compareJobProfileStatusRef = useRef(null)
  const studentPlacementRef = useRef(null)
  const compareStudentPlacementRef = useRef(null)
  const ctcAnalysisRef = useRef(null)
  const compareCtcAnalysisRef = useRef(null)
  const ctcCategoryRef = useRef(null)
  const compareCtcCategoryRef = useRef(null)
  const campusLogoRef = useRef(null)
  const logoRef = useRef(null)
  const [pdfBlob, setPdfBlob] = useState(null)
  const [progress, setProgress] = useState(0)
  const filterArr = pdfFormatFunction(state.selectedCourses)
  const { isFilteredDashboardLoading: loading } = isLoadingState

  const departmentIdArr =
    Array.isArray(state?.selectedDepartment) &&
    state?.selectedDepartment?.map(item => item.split(' ')[1])
  const specializationIdArr =
    Array.isArray(state?.selectedSpecialization) &&
    state?.selectedSpecialization?.map(item => item.split(' ')[3])
  const category = async () => {
    const result = await getJobCategory()
    const orderedCategories = [
      'PLACEMENT',
      'INTERNSHIP',
      'INTERNSHIP_PPO',
      'GIGS',
      'APPRENTICESHIP',
    ].filter(category => result?.data?.includes(category))
    setJobCategories(orderedCategories)
    return orderedCategories[0]
  }

  const { selectedCategory } = state
  const placement = selectedCategory === 'PLACEMENT'

  const studentPlacementArr = [
    {
      label: 'Students',
      key: 'totalStudents',
      color: 'rgba(255,255,255,1)',
      borderColor: '#717171',
    },
    {
      label: placement ? 'Placed' : 'Selected',
      key: 'placedStudents',
      color: '#0FB680',
    },
    {
      label: placement ? 'Un-Placed' : 'Un-Selected',
      key: 'unplacedStudents',
      color: '#F54B56',
    },
    {
      label: 'Opt-out',
      key: 'optedOutStudents',
      color: '#6B7280',
    },
  ]
  const optOutArr = [
    {
      label: 'Family Business',
      key: 'totalFamilyStudents',
      backgroundColor: [107, 114, 128],
    },
    {
      label: 'Entrepreneur',
      key: 'totalEnterpreneurStudents',
      backgroundColor: [107, 114, 128],
    },
    {
      label: 'Higher Education',
      key: 'totalHigherEducationStudents',
      backgroundColor: [107, 114, 128],
    },
    {
      label: 'Others',
      key: 'totalOtherStudents',
      backgroundColor: [107, 114, 128],
    },
  ]

  const getTpoPrimaryCard = async (instituteCampusId, value) => {
    let payLoad = {
      yearOfPassing: value,
      jobCategory: 'PLACEMENT',
    }
    setIsLoadingState(prevLoading => ({
      ...prevLoading,
      isDashboardLoading: true,
    }))
    dispatch(getTpoPrimaryCardData(instituteCampusId, payLoad, false))
    setTimeout(() => {
      setIsLoadingState(prevLoading => ({
        ...prevLoading,
        isDashboardLoading: false,
      }))
    }, 1000)
  }

  useEffect(() => {
    if (instituteCampusId) {
      getTpoPrimaryCard(instituteCampusId, state.placementDataYear)
    }
  }, [instituteCampusId])

  const handleTabClick = data => {
    setState(prev => ({
      ...prev,
      selectedCategory: data.value,
    }))
    fetchFilterDashboardDetails({ jobCategory: data?.value, cardLoading: true })
  }

  const fetchFilterJobProfileStatus = async (payLoad, compare) => {
    try {
      await dispatch(getJobProfileStatus(instituteCampusId, payLoad, compare))
    } catch (err) {
      //console.log(err, 'eeeerrrrrrrrrr')
    }
  }

  const fetchFilterCTCAnalysis = async (payLoad, compare) => {
    try {
      await dispatch(getCTCAnalysis(instituteCampusId, payLoad, compare))
    } catch (err) {
      //console.log(err, 'eeeerrrrrrrrrr')
    }
  }

  const fetchActiveJobRoles = async payLoad => {
    try {
      await dispatch(getActiveJobRoles(instituteCampusId, payLoad))
    } catch (err) {
      //console.log(err, 'eeeerrrrrrrrrr')
    }
  }

  const fetchStudentPlacement = async (payload, compare) => {
    try {
      await dispatch(getStudentPlacement(instituteCampusId, payload, compare))
    } catch (err) {
      //
    }
  }

  const fetchFilterDashboardDetails = async ({
    jobCategory = state.selectedCategory,
  } = {}) => {
    let payLoad = {}
    const addPayloadField = (field, stateField, key) => {
      const payload = stateField?.map(item => item?.value || item) || []
      if (payload.length) {
        payLoad[key] = payload.join(',')
      }
    }

    addPayloadField('domainId', state?.selectedDomain, 'domainId')
    addPayloadField('degreeId', state?.selectedDegree, 'degreeId')
    addPayloadField('streamId', departmentIdArr, 'streamId')
    addPayloadField('specializationId', specializationIdArr, 'specializationId')

    if (state?.selectedPassingYear?.year) {
      payLoad.yearOfPassing = state.selectedPassingYear.year
    }

    if (state.selectedCategory || jobCategory) {
      payLoad.jobCategory = jobCategory || state.selectedCategory
    }

    if (apiState?.degreeType) {
      let degreeType = apiState.degreeType?.split(',')
      payLoad.degreeType = [...new Set(degreeType)]?.join(',')
    }

    if (state?.selectedCourses) {
      payLoad.courses = state.selectedCourses?.flatMap(item => {
        if (item?.degree?.length > 0) {
          return item.degree.flatMap(degreeItem => {
            if (degreeItem?.department?.length > 0) {
              return degreeItem.department.flatMap(departItem => {
                if (departItem?.specialization?.length > 0) {
                  return departItem.specialization.map(specItem => ({
                    domainId: item.domainValue,
                    degreeId: degreeItem?.degreeValue,
                    streamId: departItem?.departmentValue,
                    specialisationId: specItem?.specializationValue,
                  }))
                } else {
                  return {
                    domainId: item.domainValue,
                    degreeId: degreeItem?.degreeValue,
                    streamId: departItem?.departmentValue,
                  }
                }
              })
            } else {
              return {
                domainId: item.domainValue,
                degreeId: degreeItem?.degreeValue,
              }
            }
          })
        } else {
          return {
            domainId: item.domainValue,
          }
        }
      })
    }
    setIsLoadingState(prevLoading => ({
      ...prevLoading,
      isFilteredDashboardLoading: true,
    }))
    dispatch(getTpoPrimaryCardData(instituteCampusId, payLoad, true))

    await fetchFilterJobProfileStatus(payLoad)

    await fetchFilterCTCAnalysis(payLoad)

    await fetchActiveJobRoles(payLoad)

    await fetchStudentPlacement(payLoad)
    setPayloadState(payLoad)
    setTimeout(() => {
      setIsLoadingState(prevLoading => ({
        ...prevLoading,
        isFilteredDashboardLoading: false,
      }))
    }, 1000)
  }

  const handleClickLoadData = async () => {
    const data = await category()

    setState(prevState => ({
      ...prevState,
      isLoadData: true,
      selectedCategory: data,
    }))
    fetchFilterDashboardDetails({ jobCategory: data })
  }

  const handlePlacementYearChange = newValue => {
    setState(prevState => ({
      ...prevState,
      placementDataYear: newValue,
    }))
    getTpoPrimaryCard(instituteCampusId, newValue)
  }

  useEffect(() => {
    // eslint-disable-next-line no-extra-semi
    ;(async () => {
      const res = await getInstituteDetailsFromCampusId()
      setInstituteCampusId(res?.instituteCampus[0]?.id)
      getTPOMetrics(res?.instituteCampus[0]?.id)
    })()
  }, [])

  // TPO Request Metrics

  const urgentRequestCount = useSelector(
    state => state?.tpoRequest?.tpoMetrics?.urgent_count
  )

  useEffect(() => {
    const hasPopupBeenShown = localStorage.getItem('hasShownPopup')

    if (hasPopupBeenShown === null && convertToNumber(urgentRequestCount) > 0) {
      setShowApprovalDrawer(true)
    } else {
      setShowApprovalDrawer(false)
    }
  }, [urgentRequestCount])

  const handleCloseExport = () => {
    if (step == 3) {
      setIsExport(false)
      setStep(1)
      setIsDownload(true)
      handlePDFDownload()
    } else {
      setIsExport(false)
      setStep(1)
      setExportData({
        jobProfileStatus: false,
        studentPlacement: false,
        ctcBased: false,
        ctcCategory: false,
      })
      setIsDownload(false)
      setPdfBlob(null)
      setState(prev => ({
        ...prev,
        isCompareYear: false,
        compareYear: '',
      }))
    }
  }

  const content = () => {
    return (
      <div>
        <ExportPDF
          step={step}
          data={exportData}
          setData={setExportData}
          state={state}
          yearData={yearData}
          setState={setState}
          studentPlacementRef={studentPlacementRef?.current}
          ctcAnalysisRef={ctcAnalysisRef?.current}
          ctcCategoryRef={ctcCategoryRef?.current}
          jobProfileStatusRef={jobProfileStatusRef?.current}
        />
      </div>
    )
  }

  const handleGenerateClick = async () => {
    const payLoad = { ...payloadState }
    if (state?.compareYear) {
      payLoad.yearOfPassing = state.compareYear
      await fetchFilterJobProfileStatus(payLoad, true)
      await fetchFilterCTCAnalysis(payLoad, true)
      await fetchStudentPlacement(payLoad, true)
    } else {
      console.warn('compareYear.year is missing!', state)
    }
  }

  const footer = () => {
    return (
      <FlexWrap gap="20px" right>
        <Button.Primary
          text={step == 1 ? 'Next' : step == 2 ? 'Generate' : 'Close'}
          height="38px"
          onClick={() => {
            if (step == 1) {
              setStep(2)
            } else if (step == 2) {
              handleGenerateClick()

              setStep(3)
            } else {
              setIsExport(false)
              setStep(1)
              setIsDownload(true)
              handlePDFDownload()
            }
          }}
          disabled={
            step == 2 && state?.isCompareYear && !state?.compareYear
              ? true
              : Object.keys(exportData).every(key => exportData[key] === false)
          }
        />
      </FlexWrap>
    )
  }

  const handlePDFDownload = async () => {
    await generateJobProfileStatusPDF(0)
  }

  const totalRoles = jobProfileStatusDetails?.reduce(
    (acc, currentValue) => acc + (currentValue?.roleCount || 0),
    0
  )
  const compareTotalRoles = compareJobProfileStatusDetails?.reduce(
    (acc, currentValue) => acc + (currentValue?.roleCount || 0),
    0
  )

  const generateJobProfileStatusPDF = async (initialHeight = 0) => {
    setProgress(20) // Start progress
    let progressInterval

    try {
      // Start progress incrementing every second
      progressInterval = setInterval(() => {
        setProgress(prev => (prev < 80 ? prev + 20 : prev)) // Increase progress until 80%
      }, 1000)

      const chartElement =
        jobProfileStatusRef.current?.canvas instanceof HTMLCanvasElement
          ? jobProfileStatusRef.current.canvas
          : jobProfileStatusRef.current

      // if (!chartElement) {
      //   console.error('Chart or table element not found!')
      //   return
      // }

      // Small delay to ensure element rendering
      setTimeout(async () => {
        try {
          const jobProfileHeaders = [
            { title: '%', dataKey: 'percentageValue' },
            { title: 'Statuses', dataKey: 'label' },
            {
              title: `${totalRoles} Roles Floated (All degrees)`,
              dataKey: 'roleCount',
            },
          ]
          const compareJobProfileHeaders = [
            { title: '%', dataKey: 'percentageValue' },
            { title: 'Statuses', dataKey: 'label' },
            {
              title: `${compareTotalRoles} Roles Floated (All degrees)`,
              dataKey: 'roleCount',
            },
          ]
          const studentPlacementHeaders = [
            { title: '%', dataKey: 'value' },
            { title: 'Legend', dataKey: 'label' },
            { title: 'Absolute Numbers', dataKey: 'absoluteNumbers' },
          ]
          const studentOptOutHeaders = [
            { title: '%', dataKey: 'value' },
            { title: 'Legend-Opt-Out', dataKey: 'label' },
            { title: 'Absolute Numbers', dataKey: 'absoluteNumbers' },
          ]
          const ctcAnalysisHeaders = [
            { title: '%', dataKey: 'percentageValue' },
            { title: 'Sectors', dataKey: 'label' },
            { title: 'Roles Floated', dataKey: 'total_role_floated' },
            {
              title: `Student ${state.selectedCategory === 'PLACEMENT' ? 'Placed' : 'Selected'}`,
              dataKey: 'absoluteNumbers',
            },
          ]
          const ctcCategoryHeaders = [
            { title: '', dataKey: 'value' },
            { title: 'Legend', dataKey: 'label' },
            { title: 'Absolute Numbers', dataKey: 'absoluteNumbers' },
          ]
          let data = {
            initialHeight,
            selectedCourseArr: filterArr,
            data: {
              studentPlacementData: jobProfileStatusDetails,
              studentPlacement: studentPlacementArr
                ?.slice(1)
                ?.filter(
                  item =>
                    state?.selectedCategory === 'PLACEMENT' ||
                    item.key !== 'optedOutStudents'
                )
                ?.map(item => ({
                  ...item,
                  value: studentPlacement?.percentageObj?.[item?.key] + '%',
                  absoluteNumbers:
                    studentPlacement?.totalCategoryStudentsObj?.[item?.key],
                })),
              optOutStatus: optOutArr?.map(item => ({
                ...item,
                value: studentPlacement?.optOutPercentageObj?.[item?.key] + '%',
                absoluteNumbers: studentPlacement?.optOutData?.[item?.key],
              })),
              compareJobProfileStatusData: compareJobProfileStatusDetails,
              compareStudentPlacement:
                compareStudentPlacement?.percentageObj &&
                Object.keys(compareStudentPlacement.percentageObj).length > 0
                  ? studentPlacementArr?.slice(1)?.map(item => ({
                      ...item,
                      value:
                        compareStudentPlacement?.percentageObj[item?.key] + '%',
                      absoluteNumbers:
                        compareStudentPlacement?.totalCategoryStudentsObj[
                          item?.key
                        ],
                    }))
                  : undefined,
              ctcAnalysis,
              compareCtcAnalysis,
              ctcCategory: ctcCategory?.filter(item => !item?.disable),
              compareCtcCategory: compareCtcCategory?.filter(
                item => !item?.disable
              ),
            },
            legend: {
              jobProfile: jobProfileStatusDetails,
              compareJobProfileStatus: compareJobProfileStatusDetails,
              studentPlacement: studentPlacementArr
                ?.slice(1)
                ?.filter(
                  item =>
                    state?.selectedCategory === 'PLACEMENT' ||
                    item.key !== 'optedOutStudents'
                )
                ?.map(item => ({
                  ...item,
                  value: studentPlacement?.percentageObj?.[item?.key],
                  absoluteNumbers:
                    studentPlacement?.totalCategoryStudentsObj?.[item?.key],
                })),

              compareStudentPlacement:
                compareStudentPlacement?.percentageObj &&
                Object.keys(compareStudentPlacement.percentageObj).length > 0
                  ? studentPlacementArr?.slice(1)?.map(item => ({
                      ...item,
                      value: compareStudentPlacement?.percentageObj[item?.key],
                    }))
                  : undefined,
            },
            headers: {
              jobProfile: jobProfileHeaders,
              compareJobProfile: compareJobProfileHeaders,
              studentPlacement: studentPlacementHeaders,
              optOutStatus: studentOptOutHeaders,
              ctcAnalysis: ctcAnalysisHeaders,
              ctcCategory: ctcCategoryHeaders,
            },
            state,
            exportData,
            instituteDetails,
            headerImage: {
              logo:
                logoRef.current?.canvas instanceof HTMLCanvasElement
                  ? logoRef.current.canvas
                  : logoRef.current,
              campusLogoRef:
                campusLogoRef.current?.canvas instanceof HTMLCanvasElement
                  ? campusLogoRef.current.canvas
                  : campusLogoRef.current,
            },
            chartElement: {
              studentPlacementRef:
                studentPlacementRef.current?.canvas instanceof HTMLCanvasElement
                  ? studentPlacementRef.current.canvas
                  : studentPlacementRef.current,
              jobProfileStatusRef:
                jobProfileStatusRef.current?.canvas instanceof HTMLCanvasElement
                  ? jobProfileStatusRef.current.canvas
                  : jobProfileStatusRef.current,
              ctcAnalysisRef:
                ctcAnalysisRef?.current?.canvas instanceof HTMLCanvasElement
                  ? ctcAnalysisRef?.current?.canvas
                  : ctcAnalysisRef?.current,
              ctcCategoryRef:
                ctcCategoryRef?.current?.canvas instanceof HTMLCanvasElement
                  ? ctcCategoryRef?.current?.canvas
                  : ctcCategoryRef?.current,
              compareJobProfileStatusRef:
                compareJobProfileStatusRef?.current?.canvas instanceof
                HTMLCanvasElement
                  ? compareJobProfileStatusRef?.current?.canvas
                  : compareJobProfileStatusRef?.current,
              compareStudentPlacementRef:
                compareStudentPlacementRef?.current?.canvas instanceof
                HTMLCanvasElement
                  ? compareStudentPlacementRef?.current?.canvas
                  : compareStudentPlacementRef?.current,
              compareCtcAnalysisRef:
                compareCtcAnalysisRef?.current?.canvas instanceof
                HTMLCanvasElement
                  ? compareCtcAnalysisRef?.current?.canvas
                  : compareCtcAnalysisRef?.current,
              compareCtcCategoryRef:
                compareCtcCategoryRef?.current?.canvas instanceof
                HTMLCanvasElement
                  ? compareCtcCategoryRef?.current?.canvas
                  : compareCtcCategoryRef?.current,
              campusLogoRef:
                campusLogoRef.current?.canvas instanceof HTMLCanvasElement
                  ? campusLogoRef.current.canvas
                  : campusLogoRef.current,
            },
          }

          const result = await DonutChartPDF(data)
          setPdfBlob(result)
          setProgress(100) // Complete progress
          return result
        } catch (error) {
          console.error('Error generating PDF:', error)
        } finally {
          clearInterval(progressInterval) // Stop progress updates
          setIsExport(false)

          setProgress(100) // Ensure progress reaches 100%
          setStep(1)
        }
      }, 500)
    } catch (error) {
      console.error('Unexpected error:', error)
      clearInterval(progressInterval)
      setProgress(0) // Reset progress on failure
    }
  }

  const handleDownloadPDF = () => {
    if (!pdfBlob) return
    const url = URL.createObjectURL(pdfBlob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'Dashboard_Graph.pdf'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
    setIsDownload(false)
    setState(prev => ({
      ...prev,
      isCompareYear: false,
      compareYear: '',
    }))
    setIsExport(false)

    setStep(1)
    setExportData({
      jobProfileStatus: false,
      studentPlacement: false,
      ctcBased: false,
      ctcCategory: false,
    })
    setPdfBlob(null)
  }
  const selectedCount = Object.keys(exportData).filter(
    key => exportData[key] === true
  ).length
  //console.log('Selected Count:', selectedCount)
  const download = () => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          alignItems: 'center',
          gap: '2rem',
        }}
      >
        <div style={{ flex: 1 }}>
          <StyledDynamicText>
            Exporting {selectedCount} {selectedCount === 1 ? 'Graph' : 'Graphs'}{' '}
            ({progress}% Completed)
          </StyledDynamicText>

          <Progress
            percent={progress}
            status={progress < 100 ? 'active' : 'success'}
          />
        </div>
        <Button.Primary
          text={'Download'}
          height="38px"
          onClick={() => handleDownloadPDF()}
          disabled={!pdfBlob}
        />
      </div>
    )
  }

  return (
    <BackgroundDiv>
      <PageHeader
        showHeader
        state={state}
        handleChange={handlePlacementYearChange}
        cardsData={dashboardDetails}
        loading={isLoadingState?.isDashboardLoading}
        setIsExport={setIsExport}
        exportDisable={Object.keys(filteredDashboardDetails)?.length > 0}
      />
      <hr style={{ opacity: '0.25' }} />

      <FilterComponent
        jobCategories={jobCategories}
        getYear={getYear}
        state={state}
        stateList={stateList}
        handleTabClick={handleTabClick}
        setApiState={setApiState}
        setState={setState}
        apiState={apiState}
        getDepartmentList={getDepartmentList}
        instituteCampusId={instituteCampusId}
        setStateList={setStateList}
        getDegreeList={getDegreeList}
        getDomainList={getDomainList}
        getSpecializationList={getSpecializationList}
        handleClickLoadData={handleClickLoadData}
        setFilteredDashboardDetails={setFilteredDashboardDetails}
        loading={loading}
        setYearData={setYearData}
        yearData={yearData}
        filteredDashboardDetails={filteredDashboardDetails}
      />
      {state.isLoadData ? (
        <>
          <ToggleThreeOptions
            tabs={jobCategoryFilterData(jobCategories) ?? []}
            current={state.selectedCategory}
            handleClick={e => handleTabClick(e)}
            tabMarginBottom={'25px'}
            pointerEventsNone={loading}
          />

          <br />

          <PageHeader
            state={state}
            cardsData={filteredDashboardDetails}
            loading={loading}
          />
          <TPOGraphs
            activeJobRoles={activeJobRoles}
            activeJobRolesRef={activeJobRolesRef}
            jobProfileStatusDetails={jobProfileStatusDetails}
            jobProfileStatusRef={jobProfileStatusRef}
            isExport={isExport}
            studentPlacementObj={studentPlacement}
            studentPlacementRef={studentPlacementRef}
            ctcAnalysis={ctcAnalysis}
            studentPlacement={studentPlacement?.list}
            percentageObj={studentPlacement?.percentageObj || {}}
            ctcCategory={ctcCategory}
            studentPlacementArr={studentPlacementArr}
            ctcAnalysisRef={ctcAnalysisRef}
            ctcCategoryRef={ctcCategoryRef}
            state={state}
            isDownload={isDownload}
          />
          {isDownload && state?.isCompareYear ? (
            <>
              <TPOGraphs
                jobProfileStatusDetails={compareJobProfileStatusDetails}
                jobProfileStatusRef={compareJobProfileStatusRef}
                isExport={isExport}
                studentPlacementObj={compareStudentPlacement}
                studentPlacementRef={compareStudentPlacementRef}
                ctcAnalysis={compareCtcAnalysis}
                studentPlacement={compareStudentPlacement?.list}
                percentageObj={compareStudentPlacement?.percentageObj}
                ctcCategory={compareCtcCategory}
                studentPlacementArr={studentPlacementArr}
                ctcAnalysisRef={compareCtcAnalysisRef}
                ctcCategoryRef={compareCtcCategoryRef}
                state={state}
                isDownload={isDownload}
              />
            </>
          ) : null}
          {isDownload && (
            <>
              <div ref={logoRef}>
                <div style={{ width: 200 }}>
                  <PluginLiveLogo />
                </div>
              </div>
              <div ref={campusLogoRef}>
                <img
                  src={instituteDetails?.campusLogoUrl}
                  alt="campusLogo"
                  width={80}
                  height={80}
                  crossOrigin="anonymous" // Prevents CORS issues
                  style={{ borderRadius: '50%' }}
                />
              </div>
            </>
          )}
        </>
      ) : null}

      {(!loading && Object.keys(filteredDashboardDetails)?.length === 0) ? (
        <EmptyWrapper center isSpin={''}>
          <Empty
            image={NoInterview}
            imageStyle={{ height: 360 }}
            description={''}
          />
        </EmptyWrapper>
      ) : null}

      <ShortList
        showApprovalDrawer={showApprovalDrawer}
        setShowApprovalDrawer={setShowApprovalDrawer}
        urgentCount={urgentRequestCount}
      />
      <Drawer
        width="600px"
        title={
          'Export Graphs' +
          (Object.keys(exportData).filter(key => exportData[key] === true)
            .length >= 1
            ? ` (${
                Object.keys(exportData).filter(key => exportData[key] === true)
                  .length
              } Selected)`
            : '')
        }
        placement="right"
        closable={true}
        visible={isExport}
        content={content()}
        overflowBody={'hidden'}
        onClose={() => handleCloseExport()}
        footer={footer()}
      />

      <StyledDrawer
        width="100%"
        placement="right"
        closable={true}
        visible={isDownload}
        content={download()}
        overflowBody={'hidden'}
        onClose={() => handleCloseExport()}
      />
    </BackgroundDiv>
  )
}
